import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import ContentfulImage from '../Image';
import { IconContainer } from './styles';
export const useIconSize = (size) => {
    return useMemo(() => {
        switch (size) {
            case 'Small':
                return 16;
            case 'Medium':
                return 24;
            case 'Large':
                return 32;
            default:
                return 0;
        }
    }, [size]);
};
export const useBackgroundSize = (size) => {
    return useMemo(() => {
        switch (size) {
            case 'Small':
                return 24;
            case 'Medium':
                return 32;
            case 'Large':
                return 56;
            default:
                return 0;
        }
    }, [size]);
};
const Icon = (props) => {
    const theme = useTheme();
    const { background, icon, backgroundColor = 'purple_1', inversedX, inversedY, size, rotation, } = props;
    const transform = `${inversedX ? 'scaleX(-1)' : ''} ${inversedY ? 'scaleY(-1)' : ''} ${rotation ? `rotate(${rotation})` : ''}`;
    const bgSize = useBackgroundSize(size);
    const iconSize = useIconSize(size);
    return (_jsxs(IconContainer, { style: {
            position: 'relative',
            width: bgSize,
            height: bgSize,
            flexBasis: bgSize,
            flexGrow: 0,
            flexShrink: 0,
        }, children: [!!background && (_jsx(ContentfulImage, { loading: "lazy", asset: background, style: {
                    color: theme.colors[backgroundColor],
                    transform,
                }, width: bgSize, height: bgSize })), !!icon && (_jsx(ContentfulImage, { loading: "lazy", asset: icon, style: { position: 'absolute', top: 0, right: 0 }, width: iconSize, height: iconSize }))] }));
};
export default Icon;
